export const actions = {
  PRODUCTOS_SEMANA_HOME_SELECTED_LOAD_REQUESTED: 'PRODUCTOS_SEMANA_HOME_SELECTED_LOAD_REQUESTED',
  PRODUCTOS_SEMANA_HOME_SELECTED_LOAD_SUCCEEDED: 'PRODUCTOS_SEMANA_HOME_SELECTED_LOAD_SUCCEEDED',
  PRODUCTOS_SEMANA_HOME_SELECTED_LOAD_FILED: 'PRODUCTOS_SEMANA_HOME_SELECTED_LOAD_FILED',

  PRODUCTOS_SEMANA_HOME_UPDATE_SELECTED_REQUESTED:
    'PRODUCTOS_SEMANA_HOME_UPDATE_SELECTED_REQUESTED',
  PRODUCTOS_SEMANA_HOME_UPDATE_SELECTED_SUCCEEDED:
    'PRODUCTOS_SEMANA_HOME_UPDATE_SELECTED_SUCCEEDED',
  PRODUCTOS_SEMANA_HOME_UPDATE_SELECTED_FILED: 'PRODUCTOS_SEMANA_HOME_UPDATE_SELECTED_FILED',
}
export const getProductosSemanaHomeSelectedAction = (dispatch, idiomaId) => {
  dispatch({
    type: actions.PRODUCTOS_SEMANA_HOME_SELECTED_LOAD_REQUESTED,
    payload: idiomaId,
  })
}

export const updateProductosSemanaHomeSelectedAction = (dispatch, formProductosSemanaHome) => {
  dispatch({
    type: actions.PRODUCTOS_SEMANA_HOME_UPDATE_SELECTED_REQUESTED,
    payload: formProductosSemanaHome,
  })
}
